import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/city/importer/cityImporterActions'

export default importerReducers(actions)
